import React from 'react'
import KeywordsInsightFiltersModal from './Modal'
import { KeywordsInsightFiltersDrawer } from './Drawer'

export default function KeywordsInsightFilterHandler({ open, onClose }) {
  const isMobile = window.innerWidth < 768
  return (
    <>
      {!isMobile && (
        <KeywordsInsightFiltersDrawer open={open} onClose={onClose} />
      )}

      {isMobile && (
        <KeywordsInsightFiltersModal open={open} onClose={onClose} />
      )}
    </>
  )
}
